export const ALIGNER_ACTIONS = {
  ALIGNER_CHANGE: 'ALIGNER_CHANGE',
  ISSUE_REPORT: 'ISSUE_REPORT',
  ALIGNER_CHANGE_SCHEDULED: 'ALIGNER_CHANGE_SCHEDULED',
  ALIGNER_CHANGE_OVERDUE: 'ALIGNER_CHANGE_OVERDUE',
  REMINDER_SENT: 'REMINDER_SENT',
  CHECK_IN: 'CHECK_IN',
  FORCE_ALIGNER_CHANGE: 'FORCE_ALIGNER_CHANGE',
  MOVE_TO_PREVIOUS_ALIGNER: 'MOVE_TO_PREVIOUS_ALIGNER',
  WEAR_DAYS_UPDATED: 'WEAR_DAYS_UPDATED',
  REMINDER_SENT_TO_PATIENT: 'REMINDER_SENT_TO_PATIENT',
  TREATMENT_PAUSED: 'TREATMENT_PAUSED',
  TREATMENT_RESUMED: 'TREATMENT_RESUMED',
  ALIGNER_CHANGE_PENDING_APPROVAL: 'ALIGNER_CHANGE_PENDING_APPROVAL',
  CHECK_IN_PENDING_APPROVAL: 'CHECK_IN_PENDING_APPROVAL',
  ALIGNER_CHANGE_OVERDUE_PENDING_ACTION: 'ALIGNER_CHANGE_OVERDUE_PENDING_ACTION',
  AWAITING_RESUME_APPROVAL: 'AWAITING_RESUME_APPROVAL',
  TREATMENT_DEACTIVATED: 'TREATMENT_DEACTIVATED',
  CREATE_REFINEMENT_REMINDER: 'CREATE_REFINEMENT_REMINDER',
} as const

export type AlignerActionType = keyof typeof ALIGNER_ACTIONS

export const ACTION_STATUS = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  PENDING_ACTION: 'PENDING_ACTION',
  COMPLETED: 'COMPLETED',
  OVERDUE: 'OVERDUE',
  SCHEDULED: 'SCHEDULED',
} as const

export type ActionStatus = keyof typeof ACTION_STATUS

export const ACTION_LABELS = {
  [ALIGNER_ACTIONS.ALIGNER_CHANGE]: 'Aligner change',
  [ALIGNER_ACTIONS.ISSUE_REPORT]: 'Issue reported',
  [ALIGNER_ACTIONS.ALIGNER_CHANGE_SCHEDULED]: 'Aligner change scheduled',
  [ALIGNER_ACTIONS.ALIGNER_CHANGE_OVERDUE]: 'Aligner change overdue',
  [ALIGNER_ACTIONS.REMINDER_SENT]: 'Reminder sent to patient',

  [ALIGNER_ACTIONS.CHECK_IN]: 'Check-in submitted',
  [ALIGNER_ACTIONS.FORCE_ALIGNER_CHANGE]: 'Manual Aligner Change',
  [ALIGNER_ACTIONS.MOVE_TO_PREVIOUS_ALIGNER]: 'Aligner change reverted',
  [ALIGNER_ACTIONS.WEAR_DAYS_UPDATED]: 'Aligner wear days updated',
  [ALIGNER_ACTIONS.REMINDER_SENT_TO_PATIENT]: 'Reminder sent to patient',
  [ALIGNER_ACTIONS.TREATMENT_PAUSED]: 'Treatment paused',
  [ALIGNER_ACTIONS.TREATMENT_RESUMED]: 'Treatment resumed',
  [ALIGNER_ACTIONS.ALIGNER_CHANGE_PENDING_APPROVAL]: 'Pending action',
  [ALIGNER_ACTIONS.CHECK_IN_PENDING_APPROVAL]: 'Pending action',
  [ALIGNER_ACTIONS.ALIGNER_CHANGE_OVERDUE_PENDING_ACTION]: 'Pending action',
  [ALIGNER_ACTIONS.AWAITING_RESUME_APPROVAL]: 'Awaiting resume approval',
  [ALIGNER_ACTIONS.TREATMENT_DEACTIVATED]: 'Treatment deactivated',
  [ALIGNER_ACTIONS.CREATE_REFINEMENT_REMINDER]: 'Create new treatment plan',
} as const

export const ACTION_DESCRIPTION = {
  [ALIGNER_ACTIONS.ALIGNER_CHANGE_OVERDUE_PENDING_ACTION]:
    'Extend wear days or send a reminder to patient.',
  [ALIGNER_ACTIONS.ALIGNER_CHANGE_PENDING_APPROVAL]: 'Approve change or revert aligner change.',
  [ALIGNER_ACTIONS.CHECK_IN_PENDING_APPROVAL]:
    'Approve check-in, extend wear days or send a reminder to patient.',
  [ALIGNER_ACTIONS.FORCE_ALIGNER_CHANGE]: 'Aligner changed manually',
  [ALIGNER_ACTIONS.AWAITING_RESUME_APPROVAL]: 'Resume reminder date: ',
} as const

export default ALIGNER_ACTIONS
